export const qualification = {
  rexmonster: [
    {
      id: "5e403e6f-d22f-4520-8f48-7260dfe5c865",
      text: "Bachelor Of Technology (B.Tech/B.E)",
    },
    {
      id: "a5a623ec-a04b-4ea2-b7b3-feb2b65b5b53",
      text: "Bachelor of Commerce (B.Com)",
    },
    {
      id: "488a3b0a-de62-4475-a705-54415a0748ae",
      text: "Bachelor of Science (B.Sc)",
    },
    {
      id: "b521765c-b4b2-4b92-8f8f-7862a5e0f315",
      text: "12th Class (XII)",
    },
    {
      id: "741d8f07-f39c-4605-b05c-622e2a6c2423",
      text: "Diploma",
    },
    {
      id: "0b9558ca-8aa3-4029-b990-66212988fd80",
      text: "Master OF Business Administration (M.B.A)",
    },
    {
      id: "b7dd855d-6a89-40ba-85b1-5a33430b2c27",
      text: "Bachelor of Arts (B.A)",
    },
    {
      id: "262d771c-f685-43a8-a424-70bd786549c7",
      text: "Master in Computer Application (M.C.A)",
    },
  ],
  monstergulf: [
    {
      id: "5e403e6f-d22f-4520-8f48-7260dfe5c865",
      text: "Bachelor Of Technology (B.Tech/B.E)",
    },
    {
      id: "a5a623ec-a04b-4ea2-b7b3-feb2b65b5b53",
      text: "Bachelor of Commerce (B.Com)",
    },
    {
      id: "488a3b0a-de62-4475-a705-54415a0748ae",
      text: "Bachelor of Science (B.Sc)",
    },
    {
      id: "b521765c-b4b2-4b92-8f8f-7862a5e0f315",
      text: "12th Class (XII)",
    },
    {
      id: "741d8f07-f39c-4605-b05c-622e2a6c2423",
      text: "Diploma",
    },
    {
      id: "0b9558ca-8aa3-4029-b990-66212988fd80",
      text: "Master OF Business Administration (M.B.A)",
    },
    {
      id: "b7dd855d-6a89-40ba-85b1-5a33430b2c27",
      text: "Bachelor of Arts (B.A)",
    },
    {
      id: "262d771c-f685-43a8-a424-70bd786549c7",
      text: "Master in Computer Application (M.C.A)",
    },
  ],
  monstersingapore: [
    {
      id: "5e403e6f-d22f-4520-8f48-7260dfe5c865",
      text: "Bachelor Of Technology (B.Tech/B.E)",
    },
    {
      id: "a5a623ec-a04b-4ea2-b7b3-feb2b65b5b53",
      text: "Bachelor of Commerce (B.Com)",
    },
    {
      id: "488a3b0a-de62-4475-a705-54415a0748ae",
      text: "Bachelor of Science (B.Sc)",
    },
    {
      id: "b521765c-b4b2-4b92-8f8f-7862a5e0f315",
      text: "12th Class (XII)",
    },
    {
      id: "741d8f07-f39c-4605-b05c-622e2a6c2423",
      text: "Diploma",
    },
    {
      id: "0b9558ca-8aa3-4029-b990-66212988fd80",
      text: "Master OF Business Administration (M.B.A)",
    },
    {
      id: "b7dd855d-6a89-40ba-85b1-5a33430b2c27",
      text: "Bachelor of Arts (B.A)",
    },
    {
      id: "262d771c-f685-43a8-a424-70bd786549c7",
      text: "Master in Computer Application (M.C.A)",
    },
  ],
  monsterthailand: [
    {
      id: "5e403e6f-d22f-4520-8f48-7260dfe5c865",
      text: "Bachelor Of Technology (B.Tech/B.E)",
    },
    {
      id: "a5a623ec-a04b-4ea2-b7b3-feb2b65b5b53",
      text: "Bachelor of Commerce (B.Com)",
    },
    {
      id: "488a3b0a-de62-4475-a705-54415a0748ae",
      text: "Bachelor of Science (B.Sc)",
    },
    {
      id: "b521765c-b4b2-4b92-8f8f-7862a5e0f315",
      text: "12th Class (XII)",
    },
    {
      id: "741d8f07-f39c-4605-b05c-622e2a6c2423",
      text: "Diploma",
    },
    {
      id: "0b9558ca-8aa3-4029-b990-66212988fd80",
      text: "Master OF Business Administration (M.B.A)",
    },
    {
      id: "b7dd855d-6a89-40ba-85b1-5a33430b2c27",
      text: "Bachelor of Arts (B.A)",
    },
    {
      id: "9751bad8-5ef9-11eb-b0c6-3ca82aea621c",
      text: "M.Sc",
    },
  ],
  monsterphilippines: [
    {
      id: "5e403e6f-d22f-4520-8f48-7260dfe5c865",
      text: "Bachelor Of Technology (B.Tech/B.E)",
    },
    {
      id: "a5a623ec-a04b-4ea2-b7b3-feb2b65b5b53",
      text: "Bachelor of Commerce (B.Com)",
    },
    {
      id: "488a3b0a-de62-4475-a705-54415a0748ae",
      text: "Bachelor of Science (B.Sc)",
    },
    {
      id: "b521765c-b4b2-4b92-8f8f-7862a5e0f315",
      text: "12th Class (XII)",
    },
    {
      id: "741d8f07-f39c-4605-b05c-622e2a6c2423",
      text: "Diploma",
    },
    {
      id: "0b9558ca-8aa3-4029-b990-66212988fd80",
      text: "Master OF Business Administration (M.B.A)",
    },
    {
      id: "b7dd855d-6a89-40ba-85b1-5a33430b2c27",
      text: "Bachelor of Arts (B.A)",
    },
    {
      id: "262d771c-f685-43a8-a424-70bd786549c7",
      text: "Master in Computer Application (M.C.A)",
    },
  ],
  monstervietnam: [
    {
      id: "5e403e6f-d22f-4520-8f48-7260dfe5c865",
      text: "Bachelor Of Technology (B.Tech/B.E)",
    },
    {
      id: "a5a623ec-a04b-4ea2-b7b3-feb2b65b5b53",
      text: "Bachelor of Commerce (B.Com)",
    },
    {
      id: "488a3b0a-de62-4475-a705-54415a0748ae",
      text: "Bachelor of Science (B.Sc)",
    },
    {
      id: "b521765c-b4b2-4b92-8f8f-7862a5e0f315",
      text: "12th Class (XII)",
    },
    {
      id: "741d8f07-f39c-4605-b05c-622e2a6c2423",
      text: "Diploma",
    },
    {
      id: "0b9558ca-8aa3-4029-b990-66212988fd80",
      text: "Master OF Business Administration (M.B.A)",
    },
    {
      id: "b7dd855d-6a89-40ba-85b1-5a33430b2c27",
      text: "Bachelor of Arts (B.A)",
    },
    {
      id: "262d771c-f685-43a8-a424-70bd786549c7",
      text: "Master in Computer Application (M.C.A)",
    },
  ],
  monstermalaysia: [
    {
      id: "5e403e6f-d22f-4520-8f48-7260dfe5c865",
      text: "Bachelor Of Technology (B.Tech/B.E)",
    },
    {
      id: "a5a623ec-a04b-4ea2-b7b3-feb2b65b5b53",
      text: "Bachelor of Commerce (B.Com)",
    },
    {
      id: "488a3b0a-de62-4475-a705-54415a0748ae",
      text: "Bachelor of Science (B.Sc)",
    },
    {
      id: "b521765c-b4b2-4b92-8f8f-7862a5e0f315",
      text: "12th Class (XII)",
    },
    {
      id: "741d8f07-f39c-4605-b05c-622e2a6c2423",
      text: "Diploma",
    },
    {
      id: "0b9558ca-8aa3-4029-b990-66212988fd80",
      text: "Master OF Business Administration (M.B.A)",
    },
    {
      id: "b7dd855d-6a89-40ba-85b1-5a33430b2c27",
      text: "Bachelor of Arts (B.A)",
    },
    {
      id: "262d771c-f685-43a8-a424-70bd786549c7",
      text: "Master in Computer Application (M.C.A)",
    },
  ],
  monsterindonesia: [
    {
      id: "5e403e6f-d22f-4520-8f48-7260dfe5c865",
      text: "Bachelor Of Technology (B.Tech/B.E)",
    },
    {
      id: "a5a623ec-a04b-4ea2-b7b3-feb2b65b5b53",
      text: "Bachelor of Commerce (B.Com)",
    },
    {
      id: "488a3b0a-de62-4475-a705-54415a0748ae",
      text: "Bachelor of Science (B.Sc)",
    },
    {
      id: "b521765c-b4b2-4b92-8f8f-7862a5e0f315",
      text: "12th Class (XII)",
    },
    {
      id: "741d8f07-f39c-4605-b05c-622e2a6c2423",
      text: "Diploma",
    },
    {
      id: "0b9558ca-8aa3-4029-b990-66212988fd80",
      text: "Master OF Business Administration (M.B.A)",
    },
    {
      id: "b7dd855d-6a89-40ba-85b1-5a33430b2c27",
      text: "Bachelor of Arts (B.A)",
    },
    {
      id: "262d771c-f685-43a8-a424-70bd786549c7",
      text: "Master in Computer Application (M.C.A)",
    },
  ],
  monsterhongkong: [
    {
      id: "5e403e6f-d22f-4520-8f48-7260dfe5c865",
      text: "Bachelor Of Technology (B.Tech/B.E)",
    },
    {
      id: "a5a623ec-a04b-4ea2-b7b3-feb2b65b5b53",
      text: "Bachelor of Commerce (B.Com)",
    },
    {
      id: "488a3b0a-de62-4475-a705-54415a0748ae",
      text: "Bachelor of Science (B.Sc)",
    },
    {
      id: "b521765c-b4b2-4b92-8f8f-7862a5e0f315",
      text: "12th Class (XII)",
    },
    {
      id: "741d8f07-f39c-4605-b05c-622e2a6c2423",
      text: "Diploma",
    },
    {
      id: "0b9558ca-8aa3-4029-b990-66212988fd80",
      text: "Master OF Business Administration (M.B.A)",
    },
    {
      id: "b7dd855d-6a89-40ba-85b1-5a33430b2c27",
      text: "Bachelor of Arts (B.A)",
    },
    {
      id: "262d771c-f685-43a8-a424-70bd786549c7",
      text: "Master in Computer Application (M.C.A)",
    },
  ],
};
